export function notificationPanel(variant = 'desktop') {
  return {
    variant: variant,
    showAll: false,
    loading: false,
    hideReadNotifications: false,
    allNotificationsLoaded: false,
    cachedNotificationsHtml: '',

    init() {
      setTimeout(() => this.preloadAllNotifications(), 100);
      this.setupTurboStreamListener();
    },

    setupTurboStreamListener() {
      document.addEventListener('turbo:before-stream-render', (event) => {
        const target = event.target;

        // 只處理當前 variant 的 notification_list 更新，且只在未讀通知模式時更新
        if (target && target.getAttribute && target.getAttribute('target') === `notification_list_${this.variant}`) {
          if (this.showAll) {
            event.preventDefault();
            return;
          }

          this.hideEmptyMessage();
        }
      });
    },

    async preloadAllNotifications() {
      try {
        const response = await fetch('/notifications/list', {
          headers: {
            'Accept': 'text/html',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (response.ok) {
          const html = await response.text();
          this.cachedNotificationsHtml = html;
          this.allNotificationsLoaded = true;
        }
      } catch (error) {
        console.error('背景載入通知失敗:', error);
      }
    },

    showCachedNotifications() {
      this.showAll = true;
      this.hideReadNotifications = false;
      document.getElementById(`notification_list_${this.variant}`).innerHTML = this.cachedNotificationsHtml;
      this.hideEmptyMessage();
    },

    // 載入所有通知（備用方案）
    async loadAllNotifications() {
      if (this.loading) return;

      this.loading = true;
      this.showAll = true;
      this.hideReadNotifications = false;

      try {
        const response = await fetch('/notifications/list', {
          headers: {
            'Accept': 'text/html',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (response.ok) {
          const html = await response.text();
          document.getElementById(`notification_list_${this.variant}`).innerHTML = html;
          this.hideEmptyMessage();
        }
      } catch (error) {
        console.error('載入通知失敗:', error);
      } finally {
        this.loading = false;
      }
    },

    hideReadNotificationsMethod() {
      this.hideReadNotifications = true;
      const notificationList = document.getElementById(`notification_list_${this.variant}`);
      if (notificationList) {
        const readNotifications = notificationList.querySelectorAll('[data-notification-read="true"]');
        readNotifications.forEach(notification => {
          notification.style.display = 'none';
        });
      }

      this.checkAndShowEmptyMessage();
    },

    showAllNotificationsMethod() {
      this.hideReadNotifications = false;
      const notificationList = document.getElementById(`notification_list_${this.variant}`);
      if (notificationList) {
        const allNotifications = notificationList.querySelectorAll('[data-notification-id]');
        allNotifications.forEach(notification => {
          notification.style.display = 'block';
        });
      }

      this.hideEmptyMessage();
    },

    toggleReadNotifications() {
      if (this.hideReadNotifications) {
        this.showAllNotificationsMethod();
      } else {
        this.hideReadNotificationsMethod();
      }
    },



    get buttonText() {
      if (!this.showAll) {
        return '查看所有通知';
      }

      if (this.hideReadNotifications) {
        return '查看所有通知';
      } else {
        return '隱藏已讀通知';
      }
    },

    handleButtonClick() {
      if (!this.showAll) {
        if (this.allNotificationsLoaded) {
          this.showCachedNotifications();
        } else {
          this.loadAllNotifications();
        }
      } else {
        if (this.hideReadNotifications) {
          this.showAllNotificationsMethod();
        } else {
          this.hideReadNotificationsMethod();
        }
      }
    },

    checkAndShowEmptyMessage() {
      const notificationList = document.getElementById(`notification_list_${this.variant}`);
      if (!notificationList) return;

      const visibleNotifications = notificationList.querySelectorAll('[data-notification-id]:not([style*="display: none"])');
      const emptyMessage = notificationList.querySelector('.empty-notification-message');

      if (visibleNotifications.length === 0) {
        if (!emptyMessage) {
          this.createEmptyMessage();
        } else {
          emptyMessage.style.display = 'block';
        }
      }
    },

    hideEmptyMessage() {
      const notificationList = document.getElementById(`notification_list_${this.variant}`);
      if (!notificationList) return;

      const emptyMessage = notificationList.querySelector('.empty-notification-message');
      if (emptyMessage) {
        emptyMessage.style.display = 'none';
      }
    },

    createEmptyMessage() {
      const notificationList = document.getElementById(`notification_list_${this.variant}`);
      const emptyMessageHtml = `
        <div class="empty-notification-message notify-content text-center text-gray-500 py-8">
          <p>目前沒有未讀通知</p>
        </div>
      `;
      notificationList.insertAdjacentHTML('beforeend', emptyMessageHtml);
    },
    async markAsRead(notificationId) {
      try {
        const notificationList = document.getElementById(`notification_list_${this.variant}`);
        if (!notificationList) return;

        const element = notificationList.querySelector(`[data-notification-id="${notificationId}"]`);

        // 如果已經是已讀狀態，直接返回避免重複請求
        if (element && element.getAttribute('data-notification-read') === 'true') {
          return;
        }

        const response = await fetch(`/notifications/${notificationId}/mark_as_read`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content
          }
        });

        if (response.ok) {
          if (element) {
            element.classList.remove('text-black');
            element.classList.add('text-gray-400');

            element.setAttribute('data-notification-read', 'true');

            const markReadBtn = element.querySelector('button');
            if (markReadBtn && markReadBtn.textContent.includes('標記已讀')) {
              markReadBtn.remove();
            }

            if (this.hideReadNotifications) {
              element.style.display = 'none';
              this.checkAndShowEmptyMessage();
            }

            this.updateCachedNotification(notificationId);
          }
        }
      } catch (error) {
        console.error('標記已讀失敗:', error);
      }
    },

    async toggleReadStatus(notificationId) {
      try {
        const response = await fetch(`/notifications/${notificationId}/toggle_read_status`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content
          }
        });

        if (response.ok) {
          const notificationList = document.getElementById(`notification_list_${this.variant}`);
          if (!notificationList) return;

          const element = notificationList.querySelector(`[data-notification-id="${notificationId}"]`);
          if (element) {
            const isCurrentlyRead = element.getAttribute('data-notification-read') === 'true';

            if (isCurrentlyRead) {
              element.classList.remove('text-gray-400');
              element.classList.add('text-black');
              element.setAttribute('data-notification-read', 'false');
            } else {
              element.classList.remove('text-black');
              element.classList.add('text-gray-400');
              element.setAttribute('data-notification-read', 'true');
            }

            if (this.hideReadNotifications && !isCurrentlyRead) {
              element.style.display = 'none';
              this.checkAndShowEmptyMessage();
            }

            this.updateCachedNotificationStatus(notificationId, !isCurrentlyRead);
          }
        }
      } catch (error) {
        console.error('切換已讀狀態失敗:', error);
      }
    },

    updateCachedNotification(notificationId) {
      if (this.cachedNotificationsHtml) {
        // 創建臨時 DOM 來更新快取的 HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.cachedNotificationsHtml;

        const cachedElement = tempDiv.querySelector(`[data-notification-id="${notificationId}"]`);
        if (cachedElement) {
          cachedElement.classList.remove('text-black');
          cachedElement.classList.add('text-gray-400');
          cachedElement.setAttribute('data-notification-read', 'true');

          const markReadBtn = cachedElement.querySelector('button');
          if (markReadBtn && markReadBtn.textContent.includes('標記已讀')) {
            markReadBtn.remove();
          }

          this.cachedNotificationsHtml = tempDiv.innerHTML;
        }
      }
    },

    updateCachedNotificationStatus(notificationId, isRead) {
      if (this.cachedNotificationsHtml) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.cachedNotificationsHtml;

        const cachedElement = tempDiv.querySelector(`[data-notification-id="${notificationId}"]`);
        if (cachedElement) {
          if (isRead) {
            cachedElement.classList.remove('text-black');
            cachedElement.classList.add('text-gray-400');
            cachedElement.setAttribute('data-notification-read', 'true');
          } else {
            cachedElement.classList.remove('text-gray-400');
            cachedElement.classList.add('text-black');
            cachedElement.setAttribute('data-notification-read', 'false');
          }

          this.cachedNotificationsHtml = tempDiv.innerHTML;
        }
      }
    },

    async deleteNotification(notificationId) {
      if (!confirm('確定要刪除這個通知嗎？')) return;

      try {
        const response = await fetch(`/notifications/${notificationId}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content
          }
        });

        if (response.ok) {
          const notificationList = document.getElementById(`notification_list_${this.variant}`);
          if (!notificationList) return;

          const element = notificationList.querySelector(`[data-notification-id="${notificationId}"]`);
          if (element) {
            element.remove();
          }

          this.removeCachedNotification(notificationId);

          this.checkAndShowEmptyMessage();
        }
      } catch (error) {
        console.error('刪除通知失敗:', error);
      }
    },

    removeCachedNotification(notificationId) {
      if (this.cachedNotificationsHtml) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.cachedNotificationsHtml;

        const cachedElement = tempDiv.querySelector(`[data-notification-id="${notificationId}"]`);
        if (cachedElement) {
          cachedElement.remove();
          this.cachedNotificationsHtml = tempDiv.innerHTML;
        }
      }
    },

    async markAllAsRead() {
      if (this.loading) return;

      this.loading = true;

      try {
        const response = await fetch('/notifications/mark_all_as_read', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content
          }
        });

        if (response.ok) {
          // 立即更新當前 variant 的徽章為 0
          this.updateBadgeToZero();

          // 更新當前 variant 的通知列表視覺狀態（限定範圍）
          this.updateVisibleNotifications();

          // 更新快取中的通知狀態
          this.updateAllCachedNotifications();
        }
      } catch (error) {
        console.error('標記全部已讀失敗:', error);
      } finally {
        this.loading = false;
      }
    },

    updateBadgeToZero() {
      const badge = document.getElementById(`notification_badge_${this.variant}`);
      if (badge) {
        const badgeElement = badge.querySelector('.badge');
        if (badgeElement) {
          badgeElement.remove();
        }
      }
    },

    updateVisibleNotifications() {
      const notificationList = document.getElementById(`notification_list_${this.variant}`);
      if (!notificationList) return;

      const allNotifications = notificationList.querySelectorAll('[data-notification-id]');
      allNotifications.forEach(notification => {
        notification.classList.remove('text-black');
        notification.classList.add('text-gray-400');
        notification.setAttribute('data-notification-read', 'true');
      });
    },

    updateAllCachedNotifications() {
      if (this.cachedNotificationsHtml) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.cachedNotificationsHtml;

        const cachedNotifications = tempDiv.querySelectorAll('[data-notification-id]');
        cachedNotifications.forEach(notification => {
          notification.classList.remove('text-black');
          notification.classList.add('text-gray-400');
          notification.setAttribute('data-notification-read', 'true');

          // 移除「標記已讀」按鈕（如果存在）
          const markReadBtn = notification.querySelector('button');
          if (markReadBtn && markReadBtn.textContent.includes('標記已讀')) {
            markReadBtn.remove();
          }
        });

        this.cachedNotificationsHtml = tempDiv.innerHTML;
      }
    }
  }
}
